__turbopack_context__.v({
  "className": "poppins_7488e5d4-module__JLSq7a__className",
  "variable": "poppins_7488e5d4-module__JLSq7a__variable",
});
